import api from "@/api/index";

export const productsService = {
  async getProductsByAnimalType(animalTypeId) {
    try {
      const response = await api.get(`/products?animalTypes=${animalTypeId}&tagProduit=croquettes`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des produits:", error);
      throw error;
    }
  },

  async getAllProducts() {
    try {
      const response = await api.get("/products?tagProduit=croquettes");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération de tous les produits:", error);
      throw error;
    }
  },

  async getProductVariant(code) {
    try {
      const response = await api.get(`/product-variants/${code}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du variant:", error);
      throw error;
    }
  },

  async getProductVariantPrice(variantId) {
    try {
      const response = await api.get(`/product-variants/${variantId}/price`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du prix du variant:", error);
      throw error;
    }
  },
};
